const EntryComplete = () => {
  return (
    <div
      className="entry_complete"
      style={{
        margin: "100px auto",
        maxWidth: "400px",
        textAlign: "center",
      }}
    >
      <h2
        style={{
          textAlign: "center",
          display: "contents",
        }}
      >
        エントリー内容を受け付けました。
      </h2>
      <p>
        ご入力いただいた内容は登録したメールアドレスにお送りしています。
        メールに記載されているURLからLINEグループに登録してください。
        <br />
        メールが届かない場合はアドレスにお間違いがないかご確認ください。
      </p>
      <a
        href="https://www.singbarbershop.jp/home"
        style={{
          display: "inline-block",
          marginTop: "30px",
        }}
      >
        Japan Barbershop Harmony Association
      </a>
    </div>
  );
};

export default EntryComplete;
